export default __webpack_public_path__ + "static/media/location_pin_small_new.6e93b241.svg";